export const CONFIG = {
	LOCALE: "nl-NL",
	CURRENCY: "EUR",
	HOST: "/"
};



// WEBPACK FOOTER //
// ./src/config.js